exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-container {\n  margin-bottom: 15px;\n  margin-left: 10px; }\n  .search-container .input-search-container {\n    width: 600px !important; }\n  .search-container .button-group {\n    height: 32px; }\n\n.card-list .btn-sm {\n  font-size: 12px !important;\n  width: 125px !important; }\n\n.card-list .checkmark-container {\n  margin-bottom: 17px;\n  margin-left: 7px; }\n\n.restore-all {\n  cursor: pointer; }\n\n.delete-all {\n  cursor: pointer; }\n", ""]);

// exports
